export const isDevelopment = !['production', 'staging'].includes(process.env.NODE_ENV)
